module.exports = __webpack_public_path__ + "img/warning-blue.704a57d6.svg";